import { render, staticRenderFns } from "./PortalKm.vue?vue&type=template&id=62def66a&scoped=true&"
import script from "./PortalKm.vue?vue&type=script&lang=js&"
export * from "./PortalKm.vue?vue&type=script&lang=js&"
import style0 from "./PortalKm.vue?vue&type=style&index=0&id=62def66a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62def66a",
  null
  
)

export default component.exports